<script setup lang="ts">
import EmployeeContent from './components/EmployeeContent.vue'

const authStore = useAuthStore()
const router = useRouter()

const isProcessing = ref(false)

async function handleLogout() {
  isProcessing.value = true
  await authStore.logout()

  await router.replace({ name: '/login' })
}

// Since we say that no role and permissions is an employee, we should redirect back when there are permissions
if (authStore.permissions.length > 0) {
  router.replace({ name: '/' })
}

definePage({
  name: '/employee',
  path: '/employee',
  meta: {
    allowAnonymous: false,
  },
})
</script>

<template>
  <EmployeeContent :is-processing="isProcessing" @logout="handleLogout" />
</template>
